<template>
  <div class="app-wrapper" :class="this.gridView ? 'grid-view' : null">
    <Spinner v-if="this.isLoading" />

    <!-- <Splash :splashImages="splashImages" v-show="getIsSplashOpen" /> -->
    <img
      src="https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/logos/GettyImages_White.svg"
      class="getty-logo"
      @click="isSplashOpenAction()"
    />

    <transition name="fade">
      <span
        class="nav-scroll-hint top"
        v-show="!this.navScrollStart && !this.gridView"
        ><i class="fas fa-chevron-up"></i
      ></span>
    </transition>
    <transition name="fade">
      <span
        class="nav-scroll-hint bottom"
        v-show="!this.navScrollEnd && !this.gridView"
        ><i class="fas fa-chevron-down"></i
      ></span>
    </transition>

    <nav @scroll="onNavScroll">
      <div class="v-center">
        <ul>
          <li
            v-for="(item, index) in this.collections"
            :key="index"
            :class="'#card-' + index === getActiveCard ? 'active' : null"
            @click="
              scrollTo('#card-' + index);
              activeCardAction('#card-' + index);
              track('List nav - ' + item.collection);
            "
          >
            {{ item.collection }}
          </li>
        </ul>
      </div>
    </nav>
    <!-- MENU BUTTON -->
    <button
      type="button"
      title="menu"
      class="burger-button"
      :class="getIsMenuOpen ? 'open' : null"
      @click="
        isMenuOpenAction();
        track('Menu button');
      "
    >
      <span class="burger-bar"></span>
      <span class="burger-bar"></span>
      <span class="burger-bar"></span>
    </button>

    <Menu
      :resources="resources"
      :class="getIsMenuOpen ? 'open' : null"
      :lang="getLanguage"
    />

    <transition name="fade" appear>
      <div
        v-show="getIsMenuOpen"
        class="menu-bg"
        @click="isMenuOpenAction"
      ></div>
    </transition>

    <!-- GRID VIEW TOGGLE -->
    <div class="grid-view-toggle" v-show="!this.mobileView">
      <!-- <div class="grid-view-toggle-title">View:</div> -->

      <button
        class="grid-view-button"
        :class="this.gridView ? 'active' : null"
        @click="
          this.gridView = true;
          activeCardAction('');
          track('ViewToggle - Grid view');
        "
        tooltip-data="Grid"
      >
        <i class="fas fa-th"></i>
      </button>

      <button
        class="grid-view-button"
        :class="this.gridView ? null : 'active'"
        @click="
          this.gridView = false;
          activeCardAction('');
          track('ViewToggle - Full screen view');
        "
        tooltip-data="Full screen"
      >
        <i class="fas fa-square"></i>
      </button>
      
    </div>

    <router-view
      :collections="collections"
      :splashImages="splashImages"
      :splashIntro="splashIntro"
      :pageTitle="pageTitle"
      :mobileView="mobileView"
    />
  </div>
</template>

<style>
</style>

<script>
import { mapGetters, mapActions } from "vuex";
// import splashData from './json/Splashscreen.json';
// import resourcesData from './json/Resources.json';
// import collectionsData from './json/Collections.json';
import Spinner from "./components/Spinner.vue";
import Splash from "./components/Splash.vue";
import Menu from "./components/Menu.vue";


export default {
  name: "App",
  components: {
    Spinner,
    Menu,
  },
  data() {
    return {
      isLoading: false,
      pageTitle: {
        en: "Archive collections",
        fr: "Collection archives",
        es: "Colecciones de archivo",
        de: "Archiv-Sammlung",
        it: "Contenuti d’Archivio",
        pt: "Coleção de arquivo",
        nl: "De archiefcollectie",
        jp: "アーカイブコレクション",
      },
      collections: [],
      gridView: true,
      splashImages: [],
      splashIntro: {},
      resources: {
        en: [],
        fr: [],
        es: [],
        de: [],
        it: [],
        pt: [],
        nl: [],
        jp: [],
      },
      windowWidth: window.innerWidth,
      mobileView: false,
      navScrollStart: true,
      navScrollEnd: false,
    };
  },
  computed: {
    ...mapGetters([
      "getActiveCard",
      "getIsSplashOpen",
      "getIsMenuOpen",
      "getLanguage",
    ]),
  },
  methods: {
    ...mapActions([
      "activeCardAction",
      "isSplashOpenAction",
      "isMenuOpenAction",
      "languageAction",
    ]),
    track(what) {
      this.$gtag.event("Click events", {
        event_label: what,
      });
    },
    getData() {
      this.isLoading = true;
      // use data from local json files
      const responseSplash = splashData;
      const responseCollections = collectionsData;
      const responseResources = resourcesData;
      
      responseCollections.forEach(cell => {
        this.collections.push({
          collection: cell.collection,
          summary: {
            en: cell.summary,
            fr: cell.summary_fr,
            es: cell.summary_es,
            de: cell.summary_de,
            it: cell.summary_it,
            pt: cell.summary_pt,
            nl: cell.summary_nl,
            jp: cell.summary_jp,
          },
          link: cell.link,
          image: cell.image,
          imageContain: cell.image_contain
        });
      });


      responseSplash.forEach(cell => {
        if (cell.splash_images !== undefined) {
          this.splashImages.push(cell.splash_images);
        }
        if (cell.splash_intro !== undefined) {
          this.splashIntro.en = cell.splash_intro;
          this.splashIntro.fr = cell.splash_intro_fr;
          this.splashIntro.es = cell.splash_intro_es;
          this.splashIntro.de = cell.splash_intro_de;
          this.splashIntro.it = cell.splash_intro_it;
          this.splashIntro.pt = cell.splash_intro_pt;
          this.splashIntro.nl = cell.splash_intro_nl;
          this.splashIntro.jp = cell.splash_intro_jp;
        }
      });

      responseResources.forEach(cell => {
        if (cell.resource_en !== undefined) {
          this.resources.en.push({
            resource: cell.resource_en,
            link: cell.link_en,
          });
        }
        if (cell.resource_fr !== undefined) {
          this.resources.fr.push({
            resource: cell.resource_fr,
            link: cell.link_fr,
          });
        }
        if (cell.resource_es !== undefined) {
          this.resources.es.push({
            resource: cell.resource_es,
            link: cell.link_es,
          });
        }
        if (cell.resource_de !== undefined) {
          this.resources.de.push({
            resource: cell.resource_de,
            link: cell.link_de,
          });
        }
        if (cell.resource_it !== undefined) {
          this.resources.it.push({
            resource: cell.resource_it,
            link: cell.link_it,
          });
        }
        if (cell.resource_pt !== undefined) {
          this.resources.pt.push({
            resource: cell.resource_pt,
            link: cell.link_pt,
          });
        }
        if (cell.resource_nl !== undefined) {
          this.resources.nl.push({
            resource: cell.resource_nl,
            link: cell.link_nl,
          });
        }
        if (cell.resource_jp !== undefined) {
          this.resources.jp.push({
            resource: cell.resource_jp,
            link: cell.link_jp,
          });
        }
      });

      this.isLoading = false;
    },
    scrollTo(card) {
      //scroll to card using list navigation
      this.currentCard = card;

      const wrapper = document.querySelector(".image-grid-wrapper");
      let selectedCard = document.getElementById(card);

      wrapper.scrollTo({
        top: selectedCard.offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
    onNavScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop === 0) {
        this.navScrollStart = true;
      } else {
        this.navScrollStart = false;
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        this.navScrollEnd = true;
      } else {
        this.navScrollEnd = false;
      }
    },
    onResize() {
      //detect window width to hide grid view toggle on smaller screens
      this.windowWidth = window.innerWidth;
    },
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      if (newWidth < 1000) {
        this.mobileView = true;
        this.gridView = true;
      } else {
        this.mobileView = false;
      }
    },
  },
  mounted() {
    this.getData();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      if (this.windowWidth < 1200) {
        this.mobileView = true;
        this.gridView = true;
      } else {
        this.mobileView = false;
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
